import { useState, useEffect } from "react";
import FormInput from "../../../../components/Form/FormInput";
import CheckboxField from "../../../../components/Form/CheckboxField";
import SystemValueForm from "../../../../components/SystemValue/SystemValueForm";

const SpecializationForm = ({ specToEdit, onSave, onCancel }) => {
  const [formData, setFormData] = useState({ name: "", active_flag: true });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (specToEdit) {
      setFormData({
        name: specToEdit.name,
        active_flag: specToEdit.active_flag,
      });
    } else {
      setFormData({ name: "", active_flag: true });
    }
  }, [specToEdit]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (name === "name" && !value.trim()) {
      setErrors((prev) => ({
        ...prev,
        name: "Specialization Name is required.",
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      setErrors({ name: "Specialization Name is required." });
      return;
    }
    onSave(formData);
  };

  return (
    <SystemValueForm
      title={specToEdit ? "Edit Specialization" : "Add Specialization"}
      onSubmit={handleSubmit}
      onCancel={onCancel}
    >
      <FormInput
        label="Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        onBlur={handleBlur}
        error={errors.name}
        required
      />
      <CheckboxField
        label="Active"
        name="active_flag"
        checked={formData.active_flag}
        onChange={handleChange}
      />
    </SystemValueForm>
  );
};

export default SpecializationForm;
